import { type Middleware } from '@reduxjs/toolkit';
import { removeUserAction, setUserAction } from '@common/store/reducers';
import { clearFeatureFlags } from '@common/store/reducers/featureFlags';
import { type StoreState, UserState } from '@common/types/store';
import analytics from '@common/utils/analytics';

const analyticsMiddleware: Middleware<{}, StoreState> = (store) => (
  (next) => (
    (action) => {
      if (setUserAction.match(action)) {
        const user = action.payload;
        analytics.identifyUser(user);
        import('@common/utils/analytics/applicationInsights').then((module) => {
          module.default?.setAuthenticatedUserContext(user.id, user.email);
        });
      } else if (removeUserAction.match(action)) {
        const { userState } = store.getState().main;
        if (userState === UserState.LoggedIn) {
          // Loading Application Insights starts its tracking, so only clear it after a real login
          import('@common/utils/analytics/applicationInsights').then((module) => {
            module.default?.clearAuthenticatedUserContext();
          });
        }
        if (userState !== UserState.LoggedOut) {
          analytics.cleanup();
          const result = next(action);
          // The previous user's PostHog-only flags (e.g. beta access) must not outlive the session
          store.dispatch(clearFeatureFlags());
          return result;
        }
      }
      return next(action);
    }
  )
);

export default analyticsMiddleware;
